import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal, ProgressSteps, QuickEntryModalLvl1, QuickEntryModalLvl2, QuickEntryModalLvl3 } from "../..";
import { glyphs } from "../../../Styles";

interface ReportModal_Props {
  isModalOpen: boolean
  closeModal: () => void,
}

export default function ReportModal({isModalOpen, closeModal}:ReportModal_Props) {
  const {t} = useTranslation()
  const [currentQuickEntryLevel, setCurrentQuickEntryLevel] = useState(1);

  // Function to handle Quick Entry Modal based on level
  const ShowQuickEntry = (level: 0 | 1 | 2 | 3) => {
    setCurrentQuickEntryLevel(level);
  };

  // Reset state when modal opens
  useEffect(() => {
    if (isModalOpen) {
      setCurrentQuickEntryLevel(1); // Reset to Main Info Modal
    }
  }, [isModalOpen]);

  // Function to handle "Go Back"
  const onGoBack = () => {
    if (currentQuickEntryLevel === 3) {
      ShowQuickEntry(2); // Go back to Level 2
    } else if (currentQuickEntryLevel === 2) {
      ShowQuickEntry(1); // Go back to Level 1
    } 
  }
    
  return (
    <Modal 
      isModalOpen={isModalOpen}
      overrides={{ 
        isPrimaryComponent: true 
      }}
      modalHeader={t("buttons.quickEntry")}
      // modalSubHeader={t("select")} 
      onCloseBtn={closeModal}
      onGoBack={currentQuickEntryLevel === 2 || currentQuickEntryLevel === 3? onGoBack : undefined}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "40px"}}>
        <ProgressSteps titles={[t("select")+" "+t("globalMenu.animals"), t("action"), t("buttons.view")+" "+t("changes")]} icons={[glyphs.Animal({}), glyphs.Animal({}), glyphs.Animal({})]} opacityValues={currentQuickEntryLevel === 1 ? [1, 0.5, 0.5] : currentQuickEntryLevel === 2 ? [0.5, 1, 0.5] : [0.5, 0.5, 1] }/>
        
        {currentQuickEntryLevel === 1 && <QuickEntryModalLvl1/>} {/* Select Modal */}
        {currentQuickEntryLevel === 2 && <QuickEntryModalLvl2/>} {/* Action Modal */}
        {currentQuickEntryLevel === 3 && <QuickEntryModalLvl3/>} {/* View Modal */}
        
        <Button 
          content={currentQuickEntryLevel === 1||currentQuickEntryLevel === 2 ? t("buttons.next") : t("buttons.createBtn")}
          onClick={currentQuickEntryLevel === 1 ? () => setCurrentQuickEntryLevel(2) : currentQuickEntryLevel === 2 ? () => setCurrentQuickEntryLevel(3) : () => closeModal() } // TODO CTO: On closeModal() also save to db/create report
        />
      </div>
    </Modal>
  );
}